<template>
  <div class="flipper">
    <FlipperFrame
      :imageUrl="photoA.imageUrl"
      :alt="photoA.alt"
      :caption="photoA.caption"
      :absolute="true"
      :flip="!aVisible" />
    <FlipperFrame
      :imageUrl="photoB.imageUrl"
      :alt="photoB.alt"
      :caption="photoB.caption"
      :absolute="true"
      :flip="aVisible" />
    <!-- <FlipperFrame
      v-for="(photo, i) in photos"
      :key="i + photo.alt"
      :imageUrl="photo.imageUrl"
      :alt="photo.alt"
      :caption="photo.caption" /> -->
  </div>
</template>

<script>
import FlipperFrame from "./FlipperFrame.vue";

export default {
  name: 'Flipper',
  props: ['photos'],
  components: {
    FlipperFrame
  },
  data() {
    return {
      a: 0,
      b: 1,
      aVisible: true
    }
  },
  mounted() {
    setInterval(this.flip, 5000);
  },
  methods: {
    flip() {
      this.aVisible = !this.aVisible;
      setTimeout(this.completeFlip, 1000);
    },
    completeFlip() {
      if(this.aVisible) {
        this.b = this.increment(this.a);
      }
      else {
        this.a = this.increment(this.b);
      }
    },
    increment(i) {
      if(i + 1 >= this.photos.length) {
        return 0;
      }
      return i + 1;
    }
  },
  computed: {
    photoA() {
      return this.photos[this.a];
    },
    photoB() {
      return this.photos[this.b];
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../_variables";

.flipper {
  position: relative;
  min-height: 312px;
  
  min-width: 300px;
  width: 15vw;
  max-width: 100%;

  margin-top: -40px;

  // @media screen and (max-width: $responsive-break-extra-wide) {
  //   width: 30vw;
  // }
}
</style>
